import { useState } from 'react';

import { PlayerKit } from '@components/player/player-kit';

type PlayerFaceProps = {
  imageUrl?: string;
  kitImageUrl?: string;
  teamShortName: string;
  position: 'GK' | 'DEF' | 'MID' | 'FWD';
  displayName: string;
  className?: string;
};

/**
 * Player face image with team-shirt fallback. Falls back when imageUrl is
 * empty (no enrichment yet) or when the image fails to load.
 */
export const PlayerFace = ({
  imageUrl,
  kitImageUrl,
  teamShortName,
  position,
  displayName,
  className
}: PlayerFaceProps) => {
  const [hasError, setHasError] = useState(false);

  if (!imageUrl || hasError) {
    return (
      <PlayerKit
        teamShortName={teamShortName}
        kitImageUrl={kitImageUrl}
        className={className}
      />
    );
  }

  return (
    <img
      src={imageUrl}
      alt={displayName}
      className={`object-contain ${className ?? ''}`}
      onError={() => setHasError(true)}
      data-cy="player-face"
      data-cy-team-code={teamShortName}
      data-cy-position={position}
    />
  );
};
